import axiosRetry from 'axios-retry'
import store from '../../store'
import axios from "axios";


const instance = axios.create({
    baseURL: process.env.VUE_APP_PICA_CORE_API_BASE_URL,
    headers: {
        'X-Requested-With': 'XMLHttpRequest'
    }
})

// Exponential back-off retry delay between requests, 2^N secs
axiosRetry(instance, {
    retries: 4,
    retryDelay: (retryNumber) => Math.pow(2, retryNumber) * 1000,
    retryCondition: axiosRetry.isNetworkOrIdempotentRequestError
})

const tokenString = localStorage.getItem('token')
if (tokenString) {
    try {
        const token = JSON.parse(tokenString)
        instance.defaults.headers.common['Authorization'] = `${token.type} ${token.token}`
    } catch (e) {
        // Fallback for old format
        instance.defaults.headers.common['Authorization'] = `Token ${tokenString}`
    }
}


instance.interceptors.response.use(null, async function(error) {
    const errorResponseStatus = error.response ? error.response.status : error

    if (401 === errorResponseStatus) {
        console.warn('axios interceptor: 401 error')

        // Try to refresh token if supported by current auth provider
        const state = store.state.login
        if (state.authMethod && state.refreshToken) {
            try {
                const AuthProviderFactory = require('@/domain/login/providers/AuthProviderFactory').default
                const provider = AuthProviderFactory.getProvider(state.authMethod)

                if (provider.supportsRefresh()) {
                    console.log('Attempting token refresh after 401...')

                    // Try to refresh the token
                    await store.dispatch('login/refreshAuthToken')

                    // Retry the original request with new token
                    const originalRequest = error.config
                    const newToken = store.state.login.token

                    if (newToken) {
                        originalRequest.headers['Authorization'] = `${newToken.type} ${newToken.token}`
                        return instance(originalRequest)
                    }
                }
            } catch (refreshError) {
                console.error('Token refresh failed:', refreshError)
                // If refresh fails, logout user
                await store.dispatch('login/logout')
                return Promise.reject(error)
            }
        }

        // If no refresh available or not applicable, logout
        await store.dispatch('login/logout')
    }

    return Promise.reject(error)
})

export default instance


export function getFileAndDownload(options, filename=null, retryDelay=4000) {
    return instance({
        method: options.method === undefined ? 'get' : options.method,
        url: options.url,
        params: options.params || {},
        responseType: 'blob',
        // override retry policy as download needs more time before retry
        'axios-retry': {
            retries: 3,
            retryDelay: (retryNumber) => Math.pow(2, retryNumber) * retryDelay,
            retryCondition: axiosRetry.isNetworkOrIdempotentRequestError
        }
    }).then(function(response) {
        let blob = new Blob([response.data], { type: options.fileType })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)

        if (filename === null) {
            const headerLine = response.headers['content-disposition']
            filename = headerLine.split('filename=')[1].replace(/"/g, '')
        }
        link.download = filename

        document.body.appendChild(link)
        link.click()
    })
}
